import { ReactNode, useState } from 'react';
import { useIntl } from 'react-intl';
import ConfirmationDialog from '~/components/Dialogs/ConfirmationDialog';
import { AvailableStructureSetView } from '~/domain/projections/views';
import { useLiveStructureSet } from '~/hooks/domain/useLiveStructureSet';
import useDeleteDataset from '~/hooks/useDeleteDataset';

export interface StructureSetDeletion {
    remove: (set: AvailableStructureSetView) => void;
    canRemove: (set: AvailableStructureSetView) => boolean;
    dialog: ReactNode;
}

export function useStructureSetDeletion(): StructureSetDeletion {
    const intl = useIntl();
    const { deleteStructureSet } = useDeleteDataset();
    const [target, setTarget] = useState<AvailableStructureSetView | null>(
        null
    );
    const live = useLiveStructureSet(target?.structureSetId);

    const confirm = () => {
        if (live) {
            deleteStructureSet(live);
        }
        setTarget(null);
    };

    const dialog = (
        <ConfirmationDialog
            open={target !== null}
            title={intl.formatMessage({ id: 'deleteStructureSet' })}
            message={intl.formatMessage({ id: 'deleteStructureSetConfirm' })}
            onConfirm={confirm}
            onCancel={() => setTarget(null)}
            mode="error"
        />
    );

    return {
        remove: setTarget,
        canRemove: (set) => !!set.structureSetId,
        dialog,
    };
}
